import React from "react";
import EditableLnpTable from "../../components/edit/EditableLnpTable";
import type { ConflictFieldRow } from "../../components/ui/Modal";

interface Props {
  showConfirm: (config: {
    title: string;
    message: React.ReactNode;
    confirmLabel: string;
    cancelLabel?: string;
    variant?: "primary" | "danger" | "warning";
    onConfirm: () => void;
    onCancel?: () => void;
  }) => void;
  showInfo: (config: {
    title: string;
    message: React.ReactNode;
    variant?: "success" | "info" | "warning";
  }) => void;
  showConflict: (config: {
    rowKey: string | number;
    rows: ConflictFieldRow[];
    onAcceptServer: () => void;
    onOverwrite: () => void;
  }) => void;
  closeConflict: () => void;
}

const DataEditTab: React.FC<Props> = ({
  showConfirm,
  showInfo,
  showConflict,
  closeConflict,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">Edit LNP rows</h3>

      <EditableLnpTable
        showConfirm={showConfirm}
        showInfo={showInfo}
        showConflict={showConflict}
        closeConflict={closeConflict}
      />
    </div>
  );
};

export default DataEditTab;
